import React from "react";
import TopBar from "./TopBar";
import FindLeadsOnMaps from "./FindLeadsOnMaps";
import "../styles/quotation-system.css";

export default function FindLeadsPage() {
  React.useEffect(() => {
    const metaTag = document.createElement("meta");
    metaTag.name = "robots";
    metaTag.content = "noindex";
    document.head.appendChild(metaTag);
    document.body.classList.add('quotation-page');
    return () => {
      document.head.removeChild(metaTag);
      document.body.classList.remove('quotation-page');
    };
  }, []);

  return (
    <div className="quotation-system">
      <TopBar />
      <div className="elegant-container fade-in-up">
        <div className="elegant-card">
          <FindLeadsOnMaps />
        </div>
      </div>
    </div>
  );
}

